export default function Skeleton() {
	return (
		<ul className="lp-skeleton-animation">
			<li></li>
			<li></li>
			<li></li>
			<li></li>
			<li></li>
		</ul>
	);
}
